/*
 * @Author: wangliang
 * @LastEditTime: 2023-08-22 17:25:41
 * @Description:
 * @LastEditors: wangliang wangliang@wiz.top
 */
import {
  POINT_SELETE_COLLECTION,
  MOVE_COLLECTION,
  MEASURE_COLLECTION,
  UNALLOW_COEXIST_COM,
  ROAM_COLLECTION,
} from './basicCode'

const operateTools = [
  'OF_None', // 无
  'system.Pickup', // 点选
  'OF_FreePickUp', // 自由选择
  'system.ToolHideModel', // 隐藏
  'system.PickupCenter', // 居中
]
const measureMap = {
  M_Line: 1,
  M_Point: 2,
  M_Vertical: 3,
  M_Stereo: 4,
  M_Angel: 4,
  M_Area: 6,
  M_WheelBase: 7,
  M_None: 0,
}
// key 为索引 0 递增， value 为当前类型集合
const OPERATION_COLLECTION = {
  // 只通过code调用实例 开启、关闭操作
  0: [...POINT_SELETE_COLLECTION, ...MOVE_COLLECTION, ...MEASURE_COLLECTION, ...ROAM_COLLECTION],
  1: [],
}

/**
 * @description: 根据code找到对应索引
 * @param {*} code 激活功能编码
 * @return {*}
 */
const getOperationType = (code) => {
  return _.findIndex(Object.values(OPERATION_COLLECTION), (item) => {
    return _.includes(item, code)
  })
}

/**
 * @description: 销毁基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @return {*}
 */
const destroyCloseBasicTab = async (code, player) => {
  const operationType = getOperationType(code)
  switch (operationType) {
    case 0:
      console.log('关闭功能', code)
      let closeRes = null
      if (operateTools.includes(code)) {
        closeRes = await player.Native.OperatingMode.disableOperate(operateTools.indexOf(code))
      } else if (MEASURE_COLLECTION.includes(code)) {
        // 关闭测量
        console.log('关闭测量', code)
        await player.Native.Measure.setMeasureType(0)
        await player.Native.Measure.clearAll()
      } else {
        if (ROAM_COLLECTION.includes(code)) {
          console.log('更新物理')
          await player.Native.PhysicsMgr.releasePhysicsScene()
        }
        closeRes = await player.Native.Tools.setCurrentTool('system.Browse')
      }
      return closeRes
    default:
      break
  }
  return {}
}

const removeAcitveAblity = (unAllowCode, activeBasicList, player) => {
  // 删除当前code
  _.remove(activeBasicList, (activeCode) => {
    return _.eq(activeCode, unAllowCode)
  })
  // 清空当前code对应功能
  destroyCloseBasicTab(unAllowCode, player)
}

/**
 * @description: 销毁互斥基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @param {*} activeBasicList 当前基础功能激活列表
 * @return {*}
 */
const destroyUnallowBasicTab = (code, player, activeBasicList) => {
  // 不存在互斥功能
  if (_.isEmpty(UNALLOW_COEXIST_COM[code])) {
    return
  }
  _.forEach(UNALLOW_COEXIST_COM[code], (unAllowCode) => {
    const codeIndex = _.includes(activeBasicList, code)
    if (codeIndex) {
      removeAcitveAblity(unAllowCode, activeBasicList, player)
    }
  })
}

/**
 * @description: 初始化基础功能
 * @param {*} code 激活功能编码
 * @param {*} player 模型实例
 * @param {*} activeBasicList 当前基础功能激活列表
 * @return {*}
 */
const initActiveBasicTab = async (code, player, activeBasicList) => {
  // 销毁互斥相关功能
  destroyUnallowBasicTab(code, player, activeBasicList)
  const operationType = getOperationType(code)
  console.log('打开功能', code, operationType)
  switch (operationType) {
    case 0:
      let openRes = null
      if (operateTools.includes(code)) {
        openRes = await player.Native.OperatingMode.enableOperate(operateTools.indexOf(code))
      } else if (MEASURE_COLLECTION.includes(code)) {
        // 测量
        console.log('测量', measureMap[code])
        await player.Native.Measure.setMeasureType(measureMap[code])
        if (code === 'M_None') {
          await player.Native.Measure.clearAll()
        }
      } else {
        console.log('打开的工具', code)
        if (ROAM_COLLECTION.includes(code)) {
          console.log('更新物理')
          await player.Native.PhysicsMgr.updatePhysicsScene()
        }
        openRes = await player.Native.Tools.setCurrentTool(code)
      }
      return openRes
    default:
      break
  }

  return {}
}

export { initActiveBasicTab, destroyCloseBasicTab }
